module.exports = __webpack_public_path__ + "img/creative_thumbnail-400x300.8c8024d4.jpg";